export default __webpack_public_path__ + "static/media/Flag_of_Italy.52701962.svg";